export const STORAGE_TOKEN_ERROR = 'STORAGE_TOKEN_ERROR'
export const UNAUTHORIZED = 'UNAUTHORIZED'
export const NO_PERMISSIONS = 'NO_PERMISSIONS'
export const NO_SIP = 'NO_SIP'
